module.exports = __webpack_public_path__ + "img/feature.9e11ae83.jpg";